<script>
		
</script>

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

<main>
	
	<h1>Contact Us</h1>
	<hr>
	<div class="row">
		<div class="column">
			<h2>Our Hours</h2>
			<p>Monday . . . . . . . . . 8:00am - 5:00pm</p>
			<p>Tuesday . . . . . . . . . 8:00am - 5:00pm</p>
			<p>Wednesday . . . . . . 9:00am - 6:00pm</p>
			<p>Thursday . . . . . . . . 9:00am - 6:00pm</p>
			<br>
			<div class="left-text">
				<b>Our Phone Number: </b>
				<a href="tel:+2065462322">206.546.2322</a>
				<br>
				<b>Our Fax Number: </b>
				<a href="tel:+2065423818">206.542.3818</a>
				<br>
				<b>Our Email: </b>
				<a href="mailto:info@shorelinefamilydentistry.com">info@shorelinefamilydentistry.com</a>
			</div>
			
		</div>
		<div class="column">
			<h2>Our Location</h2>
			<b><a href="https://goo.gl/maps/Wm9hRFMYtjdieFDH9">16300 Aurora Ave N  Ste G, Shoreline, WA  98133</a></b>
			<p></p>
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d670.6887858317564!2d-122.3452274!3d47.74740539999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549010e72e64f2c1%3A0xc0c3bbb59147744!2sShoreline%20Family%20Dentistry!5e0!3m2!1sen!2sus!4v1660157481527!5m2!1sen!2sus" width="400" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
		</div>
	</div>
	<br>
	<div class="row">
		<div class="columnLeft">
			<h2>Patient Forms</h2>
			<p>You can save time at your appointment by downloading, printing and filling out these forms and bringing them in with you. Please also bring your ID and current insurance card.</p>
		</div>
		<div class="columnRight">
			<br>
			<h3>Patient Form PDF Download</h3>
			<form method="get" action="/assets/patient_forms.pdf" target="_blank" rel="noopener noreferrer">
				<button class="btn"><i class="fa fa-download"></i> Download</button>
			</form>
		</div>
	</div>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	.left-text {
		text-align: left;
		padding-left: 124px;
	}


	.row {
  		display: flex;
	}

	.column {
		flex: 50%;
	}

	.columnLeft {
		flex: 60%;
	}

	.columnRight {
		flex: 40%;
	}

	.btn {
  background-color: rgb(116, 176, 211);
  border: none;
  color: white;
  padding: 12px 30px;
  cursor: pointer;
  font-size: 20px;
  transition: .1s;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: rgb(52, 80, 117);
}
</style>